import { mutationOptions, type QueryClient } from '@tanstack/react-query';

import { studioQueryKeys as legacyStudioQueryKeys } from '@/configs/react-query-keys/studio';
import { reportQueryKeys } from '@/entities/report';

import { deleteStudioItem } from './delete-studio-item';
import { studioQueryKeys } from './studio.queries';
import { updateStudioItemTitle } from './update-studio-item-title';

const LEGACY_REPORT_QUERY_KEY = ['report'] as const;

function invalidateStudioQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: studioQueryKeys.all });
  queryClient.invalidateQueries({
    queryKey: legacyStudioQueryKeys.STUDIO_ITEM_DETAIL,
  });
  queryClient.invalidateQueries({ queryKey: reportQueryKeys.all });
  queryClient.invalidateQueries({ queryKey: LEGACY_REPORT_QUERY_KEY });
}

export const updateStudioItemTitleMutationOptions = (
  queryClient: QueryClient,
) =>
  mutationOptions({
    mutationFn: updateStudioItemTitle,
    onSuccess: () => {
      invalidateStudioQueries(queryClient);
    },
  });

export const deleteStudioItemMutationOptions = (queryClient: QueryClient) =>
  mutationOptions({
    mutationFn: deleteStudioItem,
    onSuccess: () => {
      invalidateStudioQueries(queryClient);
    },
  });
